// Global
// moved to vendor bundle
import "./modules/bootstrap";
import "./modules/theme";
//import "./modules/dragula";
import "./modules/feather";
import "./modules/moment";
import "./modules/sidebar";
import "./modules/toastr";
import "./modules/user-agent";
//import "./modules/spin";
import "./modules/ladda";
import "./modules/star-rating";

// Charts
//import "./modules/chartjs";
//import "./modules/apexcharts";

// Forms 
//import "./modules/daterangepicker";
//import "./modules/datetimepicker";
//import "./modules/fullcalendar";
import "./modules/markdown";
import "./modules/mask";
//import "./modules/quill";
//import "./modules/select2";
import "./modules/validation";
//import "./modules/wizard";

// Maps
import "./modules/vector-maps";

// Tables
//import "./modules/datatables";
//import "./modules/knockout";
//import "./modules/knockout-mapping";
import "./modules/bloodhound";
import "./modules/typeahead";

import "./modules/javascript-time-ago";
import "./modules/chat/main";

// Custom Modules for Light Fish
//import "./modules/pubnub";
import * as bootstrap3Typeahead from "bootstrap-3-typeahead";

import $ from 'jquery';

import 'bootstrap/js/dist/tooltip';
import 'bootstrap/js/dist/modal';

$(function () {
    $('[data-toggle="popover"]').popover();
    // Tooltips
    // Note: Disable this if you're not using Bootstrap's Tooltips
    $('[data-toggle="tooltip"]').tooltip();

    $('.dropdown-toggle').dropdown();




    var fishlist = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.whitespace,
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        prefetch: '/documents/fishlist.json'
    });
    fishlist.initialize();

    $("#search-bar-input, #mobile-search-bar-input").typeahead({
        item: '<li class="dropdown-item"><a class="dropdown-item" href="#" role="option"></a></li>',
        showHintOnFocus: true,
        autoSelect: false,
        fitToElement: true,
        items: 4,
        source: fishlist.ttAdapter(),
        hint: true,
        highlight: true,
        minLength: 1
    });

    $('#search-bar-input').keyup(function () {
        $('#mobile-search-bar-input').val($(this).val()); // <-- reverse your selectors here
    });
    $('#mobile-search-bar-input').keyup(function () {
        $('#search-bar-input').val($(this).val()); // <-- and here
    });

    $("#mobile-search-bar-input").keydown(function (e) {
        // enter
        if (e.keyCode == 13) {
            $("#mobile-site-search-btn").click();
            return false;
        }
        // up
        if (e.keyCode == 38) {
            var activeSelectionText = $(".typeahead").find($(".dropdown-item.active a")).text();
            $("#mobile-search-bar-input").val(activeSelectionText);
            return false;
        }
        // down
        if (e.keyCode == 40) {
            var activeSelectionText = $(".typeahead").find($(".dropdown-item.active a")).text();
            $("#mobile-search-bar-input").val(activeSelectionText);
            return false;
        }
    });

    $("#search-bar-input").keydown(function (e) {


        // enter
        if (e.keyCode == 13) {
            $("#site-search-btn").click();
            return false;
        }
        // up
        if (e.keyCode == 38) {
            var activeSelectionText = $(".typeahead").find($(".dropdown-item.active a")).text();
            $("#search-bar-input").val(activeSelectionText);
            return false;
        }
        // down
        if (e.keyCode == 40) {
            var activeSelectionText = $(".typeahead").find($(".dropdown-item.active a")).text();
            $("#search-bar-input").val(activeSelectionText);
            return false;
        }
    });

    $("#site-search-form").on("click", "li", function () {
        var suggestion = $(this).data("value");
        $("#site-search-btn").click();
    });












})


//import $ from 'jquery';
//console.log($)

//import Popper from 'popper.js';

//window.jQuery = $;
//console.log(window.jQuery);
//window.$ = $;
